// extracted by mini-css-extract-plugin
export default {"closedRegistrationMessageContainer":"z2FbHC","closedRegistrationMessage":"Y5pPCA"};